// components/admin/impersonate/VenueTypeSelector.jsx
import DropdownMultiSelect from "../../UiComponents/DropdownMultiSelect";
import { venueItems } from "../../settings/venue/venueTypeDropdown/venueTypeDropdown"
import { normalize } from "../impersonate/filteringUtils";

const VenueTypeSelector = ({ selectedTypes, onChange }) => {
  const items = (venueItems ?? []).map(v => ({ key: v.label, label: v.label }));
  return (
    <DropdownMultiSelect
      items={items}
      selectedKeys={selectedTypes ?? []}
      onChange={onChange}
      placeholder="Filter venue type(s)"
    />
  );
};

export default VenueTypeSelector;
